import GroupEditor from './groups';
import ColumnEditor from './columns';
import SelectionEditor from './selected';
import OrdersEditor from './orders';
import FiltersEditor from './filters';

export { availablePropType } from './available';

const ReportSettingsEditor = {
  GroupEditor,
  ColumnEditor,
  SelectionEditor,
  OrdersEditor,
  FiltersEditor,
};

export default ReportSettingsEditor;
